import React, { useEffect, useState } from "react";
import { useAuth } from "../../Hooks/Auth";
import { UserFullContext } from "../../Hooks/ContextUser";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ChangeCollaboratorPasswordUseCase } from "../../Usecase/Collaborators/change-collaborator-password-usecas";
import { CollaboratorsApiRemoteService } from "../../Services/api/collaborators/collaborators-service";
import api from "../../Services/api";
import { useToast } from "../../Hooks/ToasContext";
import { UserProps } from "../../Hooks/Auth";

export function useAccountMenu() {
    const { signOut, user, updateUser } = useAuth()
    const [searchParams] = useSearchParams();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [openDialog, setOpenDialog] = useState(false);
    const [forceReset, setForceReset] = useState(false);
    const [loading, setLoading] = useState(false);
    const { showToast } = useToast();
 
    const changeCollaboratorPasswordUseCase = new ChangeCollaboratorPasswordUseCase(new CollaboratorsApiRemoteService(api))
    

    const handleChangePassword = async(data: any) => {
       
        setLoading(true);
        try {
            await changeCollaboratorPasswordUseCase.handle(data.password);
            setOpenDialog(false);
            setForceReset(false);
            updateUser({ ...user, resetPassword: false } as UserProps);
            navigate('/');
            showToast('Senha alterada com sucesso', 'success');
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }
    
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
  
    const { Logout : LogoutUser } = UserFullContext()
      const navigate = useNavigate();
  
      const handleLogout = async() => {
          // LogoutUser()
          // navigate('/')
          signOut()
      }

      useEffect(() => {
        const resetPasswordParam = searchParams.get('resetPassword');
        if (user?.resetPassword || resetPasswordParam) {
          setForceReset(true);
          setOpenDialog(true);
        }
      }, [user, searchParams])

    return {
        openDialog,
        setOpenDialog,
        loading,
        setLoading,
        handleClick,
        handleClose,
        handleLogout,
        open,
        anchorEl,
        handleChangePassword,
        forceReset,

    }
}